export default angular.module('mars.vet.dnareports.controllers.atrisk',[])
	.controller('AtRiskController', function($rootScope, $scope, $window, EntryService, EntryIDService, ImageService,DisorderDataService, NavigationService, TranslationService, reportdata,disorderData) {
    let sampleDetails = reportdata.sampleDetails;

    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }
    EntryService.getEntry(EntryIDService.getEntryID('At Risk')).then(function(response) {
        var fields = response.fields;
        if (reportType != 'pdf') {
            $rootScope.pageTitle = fields.title;
        }
        $scope.title = fields.title;
        $scope.description = fields.description.replaceAll('[PETNAME]', sampleDetails.petDetails.petName);
        $scope.copyDescription = fields.copyDescription.replaceAll('[PETNAME]', sampleDetails.petDetails.petName);
    });

    ImageService.getImageUrl('3Wnl92bJlSmi6gIYKKkE0C').then(function(response) {
        $scope.mainStatusIcon = response.data.fields.file.url;
    });
    ImageService.getImageUrl('6ucbwArbUcuYsYYKmemcWM').then(function(response) {
        $scope.subStatusIcon = response.data.fields.file.url;
    });
    ImageService.getImageUrl("M2jxxG0NKmumcEkciqmg0").then(function(response) {
        $scope.wsuLogo = response.data.fields.file.url;
    });

    $scope.translation = TranslationService.getTranslation;
    
	NavigationService.setNavigationUrls();
	$scope.atRiskDataList = DisorderDataService.getAtRiskData();
	$scope.locale = reportdata.locale;
	var init=function(){
    $rootScope.$broadcast('checkGenHealthCount',$scope.atRiskDataList.length);
    }
    init();
    $window.ga('send', 'pageview', {
        'page': $scope.title
    });
}).directive('tooltip', function(){
    return {
        restrict: 'A',
        link: function(scope, element, attrs){
            $(element).hover(function(){
                // on mouseenter
                $(element).tooltip('show');
            }, function(){
                // on mouseleave
                $(element).tooltip('hide');
            });
        }
    };
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/atrisk.controller.js